<template>
  <div>
    <div class="recommend-goods">
      <div>选择推荐商品</div>
      <div class="recommend-goods-box">
        <el-form :inline="true" size="small">
          <el-form-item>
            <el-select
              v-model="searchFrom.oneGoodsOperationalClassId"
              style="width: 180px"
              @change="searchHandleOne"
            >
              <el-option
                v-for="item in classListOne"
                :key="item.id"
                :label="item.name"
                :value="item.id"
              >
              </el-option>
            </el-select>
          </el-form-item>
          <el-form-item>
            <el-select
              v-model="searchFrom.twoGoodsOperationalClassId"
              style="width: 180px"
              @change="searchHandleTwo"
            >
              <el-option
                v-for="item in classListTwo"
                :key="item.id"
                :label="item.name"
                :value="item.id"
              >
              </el-option>
            </el-select>
          </el-form-item>
          <el-form-item>
            <el-select
              v-model="searchFrom.threeGoodsOperationalClassId"
              style="width: 180px"
            >
              <el-option
                v-for="item in classListThree"
                :key="item.id"
                :label="item.name"
                :value="item.id"
              >
              </el-option>
            </el-select>
          </el-form-item>
          <el-form-item>
            <el-input
              v-model="searchFrom.name"
              style="width: 180px"
              placeholder="药品名称"
            ></el-input>
          </el-form-item>
          <el-form-item>
            <el-input
              v-model="searchFrom.factory"
              style="width: 180px"
              placeholder="厂家名称"
            ></el-input>
          </el-form-item>
          <el-button
            size="small"
            type="success"
            :disabled="showShop && !searchFrom.shopId"
            @click="onQuery()"
            >检索</el-button
          >
          <el-button
            size="small"
            type="info"
            :disabled="showShop && !searchFrom.shopId"
            @click="onReset()"
            >重置</el-button
          >
          <el-button
            size="small"
            type="primary"
            :disabled="showShop && !searchFrom.shopId"
            @click="onSubmit()"
            >确定</el-button
          >
        </el-form>
        <div>
          <div class="contentContinner">
            <GoodsList ref="goodsRef" :goods-data="goodsData" />
          </div>
          <el-pagination
            @current-change="handleCurrentChange"
            :current-page.sync="searchFrom.current"
            layout="total,prev, pager, next, jumper"
            :total="searchFrom.total"
            style="text-align: end"
          >
          </el-pagination>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { queryGoodsClassList } from "@/api/productManage/goodsManger";
import GoodsList from "./goodsList";
import { getShopGoodsByShopIdList } from "@/api/recommendationHome";
import Pagination from "@/components/Pagination";

export default {
  props: {
    shopInfo: {
      type: Object,
      default: () => null,
    },
  },
  components: { GoodsList, Pagination },
  data() {
    return {
      searchFrom: {
        shopId: "",
        oneGoodsOperationalClassId: "",
        twoGoodsOperationalClassId: "",
        threeGoodsOperationalClassId: "",
        name: "",
        factory: "",
        current: 1,
        size: 10,
        total: 0,
      },
      showShop: true,
      classListOne: [],
      classListTwo: [],
      classListThree: [],
      goodsData: [],
    };
  },
  computed: {},
  watch: {
    shopInfo: {
      handler(val) {
        this.searchFrom.shopId = val?.shopId;
        this.searchFrom = {...this.searchFrom}
      },
      deep: true,
    },
  },
  created() {},
  mounted() {},
  beforeCreate() {},
  beforeMount() {},
  beforeUpdate() {},
  updated() {},
  beforeDestroy() {},
  destroyed() {},
  activated() {},
  methods: {
    clearData() {
      this.searchFrom = {
        shopId: "",
        oneGoodsOperationalClassId: "",
        twoGoodsOperationalClassId: "",
        threeGoodsOperationalClassId: "",
        name: "",
        factory: "",
        current: 1,
        size: 10,
        total: 0,
      };
      this.$refs.goodsRef.currentIndex = -1;
      this.classListOne = [];
      this.classListTwo = [];
      this.classListThree = [];
      this.goodsData = [];
    },
    getClassify1() {
      this.classListOne = [];
      queryGoodsClassList().then((res) => {
        if (res.code == 0 && res.data) {
          this.getClassifyTwo(res.data[0].id);
          this.classListOne = res.data;
        } else {
          this.tableData = [];
        }
      });
    },
    getClassifyTwo(id) {
      this.classListTwo = [];
      queryGoodsClassList({ currentId: id, levelParam: 2 }).then((res) => {
        if (res.code == 0 && res.data) {
          this.getClassifyThree(res.data[0].id);
          this.classListTwo = res.data;
        } else {
          this.tableData = [];
        }
      });
    },
    getClassifyThree(id) {
      this.classListThree = [];
      queryGoodsClassList({ currentId: id, levelParam: 3 }).then((res) => {
        if (res.code == 0 && res.data) {
          this.classListThree = res.data;
        } else {
          this.tableData = [];
        }
      });
    },

    getGoodsList() {
      console.log('this.searchFrom--->',this.searchFrom);
      getShopGoodsByShopIdList(this.searchFrom).then((res) => {
        if (res.code == 0) {
          const { records, total } = res.data;
          this.goodsData = records;
          this.searchFrom.total = total;
        }
      });
    },
    searchHandleOne(e) {
      this.searchFrom.twoGoodsOperationalClassId = "";
      this.searchFrom.threeGoodsOperationalClassId = "";
      this.getClassifyTwo(e);
    },
    searchHandleTwo(e) {
      this.searchFrom.threeGoodsOperationalClassId = "";
      this.getClassifyThree(e);
    },
    onQuery() {
      this.getGoodsList();
    },
    onReset() {
      this.searchFrom.oneGoodsOperationalClassId = "";
      this.searchFrom.twoGoodsOperationalClassId = "";
      this.searchFrom.threeGoodsOperationalClassId = "";
      this.searchFrom.threeGoodsOperationalClassId = "";
      this.searchFrom.name = "";
      this.searchFrom.factory = "";
      this.searchFrom.current = 1;
      this.searchFrom.total = 0;
      this.goodsData = [];
    },
    onSubmit() {
      if (this.$refs.goodsRef.currentIndex == -1) {
        this.$message.warning("请先选择商品！");
        return;
      }

      const { form } = this.$refs.goodsRef;
      this.$emit("submit", form);
    },
    chooseItem() {},
    handleCurrentChange(val) {
      this.searchFrom.current = val;
      this.$refs.goodsRef.currentIndex = -1;
      this.getGoodsList();
    },
  },
};
</script>
<style lang="scss" scoped>
.recommend-goods {
  margin-top: 20px;
  &-box {
    margin-top: 10px;
  }

  .contentContinner {
    display: flex;
    margin: 0x auto;
    justify-content: flex-start;
    flex-wrap: wrap;
    align-content: flex-start;
  }
}
</style>
